type Options = {
    pattern?: RegExp
    type: 'letter' | 'number'
}

/**
 * @name useFilter
 * @param String {string} Example: 'John@5656//'
 * @param Options {Options} Example: { pattern: /[^\W]/g, type: 'letter' } || { pattern: /[^\d]/g, type: 'number' }
 * @returns {string} Example: 'John5656' || '5656' || 'John'
 */

function useFilter(String: string, Options: Options): string {
    const { pattern, type } = Options
    if (type === 'letter') {
        return String.replace(pattern ?? /[^a-zA-Z]/g, '')
    }
    if (type === 'number') {
        return String.replace(pattern ?? /[^0-9]/g, '')
    }
}

export { useFilter }
